module.exports = __webpack_public_path__ + "28c351a1b7e5027d490f0e6bb5215fdf.pdf";